export default "__VITE_ASSET__5dc3ebd9__"